import React from 'react';
import { useMountEffect } from '@/hooks/useMountEffect.ts';
import { AppName } from '@/types/misc.def.ts';

type PageTitleProps = {
  value: string;
};

const PageTitleSync: React.FC<PageTitleProps> = ({ value }) => {
  useMountEffect(() => {
    document.title = `${value} | ${AppName}`;

    return () => {
      document.title = `${AppName}`;
    };
  });

  return null;
};

export const PageTitle: React.FC<PageTitleProps> = ({ value }) => (
  <PageTitleSync key={value} value={value} />
);
